export function SchoolIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M10.0002 2.5L0.833496 7.5L4.16683 9.31667V14.3167L10.0002 17.5L15.8335 14.3167V9.31667L17.5002 8.40833V14.1667H19.1668V7.5L10.0002 2.5ZM15.6835 7.5L10.0002 10.6L4.31683 7.5L10.0002 4.4L15.6835 7.5ZM14.1668 13.325L10.0002 15.6L5.8335 13.325V10.225L10.0002 12.5L14.1668 10.225V13.325Z"
        fill="#272B2F"
      />
    </svg>
  )
}
